import { ArrowDown, ArrowUp } from "lucide-react"
import { Button } from "@/components/ui/Button"
import type { SortDir } from "../types"

interface Props {
  sortKey: string
  /** Direction when this column is the active sort; null otherwise. */
  active: SortDir | null
  onSort: (key: string) => void
  align: "left" | "right"
  children: React.ReactNode
  /** Small line under the label, e.g. "partial". */
  note?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

const ARIA_SORT: Record<SortDir, "ascending" | "descending"> = { asc: "ascending", desc: "descending" }

/** Column heading that sorts the table on click. The arrow marks the active column. */
export default function SortableHead({ sortKey, active, onSort, align, children, note, className, style }: Props) {
  const Arrow = active === "asc" ? ArrowUp : ArrowDown
  return (
    <th className={className} style={style} aria-sort={active ? ARIA_SORT[active] : "none"}>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onSort(sortKey)}
        title="Click to sort"
        className={`h-auto px-0 py-0 text-[13px] font-medium hover:bg-transparent hover:text-foreground ${
          active ? "text-foreground" : "text-muted-foreground"
        }`}
      >
        <span className={`flex flex-col ${align === "right" ? "items-end" : "items-start"}`}>
          <span>{children}</span>
          {note}
        </span>
        {active && <Arrow size={12} className="ml-1" aria-hidden />}
      </Button>
    </th>
  )
}
